module.exports = __webpack_public_path__ + "static/media/MainSignUp.0977c4fd.png";